module.exports = __webpack_public_path__ + "static/media/national-2-web-bold.c48c1050.eot";